<template>
  <div class="page-teacher-report">
    <report-header :basicInfo="datas" textName @changeClassByData="changeClassByData" />

    <practice-content :type="scienceArr.includes(Number(datas.subject_id))" :overviewData="datas" />
  </div>
</template>

<script>

import { getOverview, getStuScoreList } from '@/api/pt';
import PracticeContent from '@/views/pt/teacher-report/components/practice-content.vue';
import ReportHeader from '@/views/pt/teacher-report/components/report-header.vue';

export default {
  name: 'TeacherReport',
  components: {
    ReportHeader,
    PracticeContent,
  },
  data() {
    return {
      activeName: 'tea-practice',
      offsetClass: 'l-0',
      scienceArr: [2, 4, 5],
      params: {},
      datas: {},
      studentData: [], // 学生列表
      changeClassColumn: {}, // 记录变更后的值
    };
  },
  methods: {
    onTabClick(e) {
      this.offsetClass = `l-${e.index}`;
      this.activeName = e.name;
    },
    getData() {
      getOverview({
        school_id: this.params.schoolId,
        evaluate_id: this.params.evaluateId,
      }).then((res) => {
        if (res.code === 200) {
          this.datas = res.data;
        } else {
          this.$message({
            type: 'warning',
            message: res.msg,
          });
        }
      }).catch((e) => {
        console.log(e);
        this.$message({
          type: 'warning',
          message: e.msg,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    // 改变父组件值
    onChangeData(data) {
      this.studentData = data;
    },
    changeClassByData(data) {
      this.changeClassColumn = data;
      this.params = {
        ...this.params,
        evaluateId: data.evaluate_id,
        schoolId: data.school_id,
        batchId: data.batch_id,
      };
      this.getData();
      this.getStudentScoreList('', this.changeClassColumn);
    },
    // 学生接口
    getStudentScoreList(value, data) {
      const { evaluateId, schoolId, classId } = this.$route.query;
      return getStuScoreList({
        evaluate_id: data.evaluate_id
          ? data.evaluate_id : evaluateId,
        school_id: schoolId,
        class_id: data.class_id ? data.class_id : classId,
        name: value,
      }).then((res) => {
        if (res.code === 200) {
          this.studentData = res.data || [];
          // 首次默认按倒叙排
          if (Number(this.params.fromType) === 3) {
            this.studentData.sort(this.compareSort('avg_right_rate', ''));
          } else {
            this.studentData.sort(this.compareSort('cost_time', ''));
          }
        }
      });
    },
    // 排序处理
    compareSort(data, type) {
      return (a, b) => {
        const sortA = a[data];
        const sortB = b[data];
        if (type === 'ascending') {
          return sortA - sortB;
        }
        return sortB - sortA;
      };
    },
  },
  created() {
    this.getStudentScoreList('', {});
  },
  mounted() {
    // 区分MT和AMT模式
    this.params = this.$route.query;
    console.log(this.params, 'wang');
    if (Number(this.params.fromType) === 4) {
      this.tabList = this.tabList.filter((item) => item.name !== 'tea-content');
    }
    this.getData();
  },
  destroyed() {
    this.changeClassColumn = {};
  },
};
</script>

<style lang="scss" scoped>
.page-teacher-report {
  padding: 32px 32px 10px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
}
/deep/ .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0;
}

/deep/ .el-tabs__nav-wrap {
  overflow: hidden;
  margin-bottom: -1px;
  position: relative;
  border-bottom: 9px solid #ebeef5;
}
// element tag 样式覆盖
.i-tab {
  /deep/ {
    .el-tabs__item {
      font-size: 17px;
      width: 100px;
      text-align: center;
      height: 56px;
      line-height: 56px;
      padding: 0 !important;
      margin: 0 20px;
      &.is-active {
        color: rgba(25, 137, 250, 1);
      }
    }
    .el-tabs__nav-wrap {
      overflow: visible;
      display: flex;
    }
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs__active-bar {
      background-color: rgba(25, 137, 250, 1);
      height: 3px;
      border-radius: 2px;
      width: 100px !important;
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 13px;
        height: 13px;
        border: 2px solid rgba(25, 137, 250, 1);
        box-sizing: border-box;
        background: #fff;
        border-radius: 50%;
        top: -4px;
      }
    }
  }
}
.l-0 /deep/ {
  .el-tabs__active-bar {
    left: 18px;
  }
}
.l-1 /deep/ {
  .el-tabs__active-bar {
    left: 54px;
  }
}
.l-2 /deep/ {
  .el-tabs__active-bar {
    left: 96px;
  }
}
.l-3 /deep/ {
  .el-tabs__active-bar {
    left: 138px;
  }
}
</style>
